import {
  get,
  compact,
  head,
  values as objValues,
  pick,
  toString,
  isEmpty,
  toNumber,
} from 'lodash'

// eslint-disable-next-line
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validate = validators => (value, values) =>
  head(compact(validators.map(validator => validator(value, values))))

export const confirmation = (name, message = `Must be equal to ${name}`) => (
  value,
  values,
) => {
  if (value !== get(values, name)) {
    return message
  }
  return undefined
}

export const presence = (message = 'Is required') => value =>
  value ? undefined : message

export const isNumberValidation = (
  message = 'Invalid value. It should be a number',
) => value => (isEmpty(value) || /^-?\d+$/.test(value) ? undefined : message)

export const isLessThan = (
  comparedValue = 0,
  message = `It should be less than ${comparedValue}`,
) => value => {
  return isEmpty(value) || toNumber(value) < toNumber(comparedValue)
    ? undefined
    : message
}

export const isDifferentThan = (
  comparedValue,
  message = `It should be different from ${comparedValue}`,
) => value =>
  isEmpty(value) || toString(value) !== toString(comparedValue)
    ? undefined
    : message

export const richTextPresence = (message = 'Is required') => value => {
  const str = value || ''
  // If there is any text content after stripping tags, it's present
  const strippedText = str.replace(/<[^>]*>?/gm, '').trim()
  if (strippedText.length > 0) return undefined

  // Accept presence if the HTML contains common embed tags
  const hasEmbed = /<(iframe|video|img|embed|object)(\s|>)/i.test(str)
  return hasEmbed ? undefined : message
}

export const email = (message = 'Invalid email') => value =>
  value && !EMAIL_REGEX.test(value) ? message : undefined

export const minLength = (
  chars,
  message = `Minimum ${chars} characters`,
) => value => (value && value.trim().length < chars ? message : undefined)

export const getFieldError = formState => name =>
  get(formState, `touched.${name}`) && get(formState, `errors.${name}`)

export const getFieldProps = (fields, formState) => (
  type,
  name,
  validators = [],
) => {
  const fieldError = getFieldError(formState)
  return {
    ...get(fields, type)({ name, validate: validate(validators) }),
    error: fieldError(name),
  }
}

export const isValidForm = formState =>
  !compact(objValues(formState.errors)).length

export const isEmptyForm = formState =>
  !compact(objValues(formState.values)).length

export const isFulfilled = (formState, { fieldsToLook } = {}) => {
  if (!fieldsToLook)
    return (
      objValues(formState.values).length ===
      compact(objValues(formState.values)).length
    )

  return (
    fieldsToLook.length ===
    compact(objValues(pick(formState.values, fieldsToLook))).length
  )
}
